"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScholarshipRequirementType = void 0;
var ScholarshipRequirementType;
(function (ScholarshipRequirementType) {
    ScholarshipRequirementType["CREATED_ACCOUNT"] = "created_account";
    ScholarshipRequirementType["EMAIL_SUBSCRIPTIONS"] = "email_subscriptions";
    ScholarshipRequirementType["STUDY_PREFERENCES"] = "study_preferences";
    ScholarshipRequirementType["BEST_FIT"] = "best_fit";
    ScholarshipRequirementType["REVIEW"] = "review";
    ScholarshipRequirementType["APPLIED"] = "applied";
    ScholarshipRequirementType["APPLICATION_LETTER"] = "application_letter";
    ScholarshipRequirementType["CONFIRM_ACCEPTANCE"] = "confirm_acceptance";
})(ScholarshipRequirementType = exports.ScholarshipRequirementType || (exports.ScholarshipRequirementType = {}));
